import axios, { AxiosError } from "axios";
const CustomerContactResource = {
    get(customerId, customerContactId, resultFunc, errorFunc, finallyFunc) {
        axios.get(`/admin/v1/customers/${customerId}/contacts/${customerContactId}`)
            .then(response => resultFunc(response.data))
            .catch(errorFunc)
            .finally(finallyFunc);
    },
    create(customerId, request, resultFunc, errorFunc, finallyFunc) {
        axios.post(`/admin/v1/customers/${customerId}/contacts/`, request)
            .then(response => resultFunc(response.data))
            .catch(errorFunc)
            .finally(finallyFunc);
    },
    update(customerId, customerContactId, request, resultFunc, errorFunc, finallyFunc) {
        axios.put(`/admin/v1/customers/${customerId}/contacts/${customerContactId}`, request)
            .then(response => resultFunc(response.data))
            .catch(errorFunc)
            .finally(finallyFunc);
    },
    patch(customerId, customerContactId, disableAt, resultFunc, errorFunc, finallyFunc) {
        axios.patch(`/admin/v1/customers/${customerId}/contacts/${customerContactId}`, { disableAt })
            .then(response => resultFunc(response.data))
            .catch(errorFunc)
            .finally(finallyFunc);
    },
    inviteCustomerContact(customerId, customerContactId, request, resultFunc, errorFunc, finallyFunc) {
        axios.post(`/admin/v1/customers/${customerId}/contacts/${customerContactId}/users`, request)
            .then(response => resultFunc(response.data))
            .catch(errorFunc)
            .finally(finallyFunc);
    },
    patchCustomerUserAccess(customerId, customerContactId, request, resultFunc, errorFunc, finallyFunc) {
        axios.patch(`/admin/v1/customers/${customerId}/contacts/${customerContactId}/users`, request)
            .then(response => resultFunc(response.data))
            .catch(errorFunc)
            .finally(finallyFunc);
    },
    ostraciseCustomerUser(customerId, customerContactId, resultFunc, errorFunc, finallyFunc) {
        axios.delete(`/admin/v1/customers/${customerId}/contacts/${customerContactId}/users`)
            .then(( /*response*/) => resultFunc())
            .catch(errorFunc)
            .finally(finallyFunc);
    },
};
export default CustomerContactResource;
